import { z } from 'zod';
import { expectType, zDocument, zTreeFields, zFeedbackFields } from './model.js';
import { zAuthorFields, zFullAuthorFields } from './user.js';
import { zTotalEngagementFields } from './postView.js';
// Simple Comment, just some text
export const zCommentBase = zDocument.extend({
    type: z.literal('comment'),
    comment: z.string().max(10000),
    commentModerationReason: z.string().max(1000)
});
// The ZodObject for a Comment, this is what's stored in the DB
// Editable adds the history and editCount fields. This also includes the tree fields which are
// just id pointers to other objects. This is basically a 'dehydrated' comment.
export const zComment = zCommentBase.merge(zAuthorFields).merge(zTreeFields);
expectType({});
expectType({});
expectType({});
expectType({});
const TFullCommentFields = zCommentBase
    .merge(zAuthorFields)
    .merge(zFullAuthorFields)
    .merge(zFeedbackFields)
    .merge(zTreeFields)
    .merge(zTotalEngagementFields);
expectType({});
expectType({});
// Then we use zod's special lazy syntax for recursive types to add the children field
// and the other tree fields. This is the final type for a fully hydrated comment type.
// Note we leave the root and parent fields as strings, because we don't want to hydrate them, it would
// create a circular object graph.
export const zFullComment = z.lazy(() => TFullCommentFields.merge(z.object({
    fullChildren: z.array(zFullComment)
})));
expectType({});
expectType({});
export const zCommentableFields = z.object({
    displayComments: z.boolean(),
    closedForComments: z.boolean()
});
export const zTotalCommentsFields = z.object({
    totalComments: z.number()
});
expectType({});
expectType({});
// Validate zod schema matches
expectType({});
expectType({});
export const EmptyNewComment = {
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    type: 'comment',
    author: '',
    root: '',
    rootType: 'post',
    parent: '',
    parentType: 'post',
    comment: '',
    commentModerationReason: '',
    children: []
};
export const EmptyComment = {
    ...EmptyNewComment
};
export function isComment(doc) {
    return doc.type === 'comment';
}
export function isDirectMessage(doc) {
    return doc.type === 'directMessage';
}
